import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Angulartics2GoogleTagManager } from 'angulartics2';

import versionJSON from '../assets/version.json';

@Component({
  selector: 'pd-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent {
  private gtag = inject(Angulartics2GoogleTagManager);

  @HostBinding('attr.version') version: string;

  constructor() {
    this.gtag.startTracking();
    this.version = versionJSON.version;
  }
}
